import { useTranslation } from 'react-i18next';

export const Servers = () => {
  const { t } = useTranslation();
  return <>{t('common.work-in-progress')}</>;
};
